import React from 'react';
import PropTypes from 'prop-types';
import ReactSlick from 'react-slick';
import './styles.css';

/**
 * PromoSlider
 */
const PromoSlider = ({
                                    children,
                                  }) => {
  const settings = {
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    fade: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    swipe: true,
    draggable: false,
    arrows: true,
    dots: true,
    adaptiveHeight: false,
    centerMode: false,
    centerPadding: 0,
    lazyLoad: 'progressive'
  };
  //
  return (
    <div className="PromoSlider">
      <ReactSlick {...settings}>
        {children.map((child, index) => {
          return (
            child
          )
        })}
      </ReactSlick>
    </div>
  )
};
PromoSlider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
};
PromoSlider.defaultProps = {
  children: null,
};
export default PromoSlider;



// WEBPACK FOOTER //
// ./src/containers/promo-slider/index.jsx